module.exports = __webpack_public_path__ + "static/media/3-first_section.656e9edd.png";